import React, { useState } from 'react';
import { Button, Badge } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import logopro from '../../Images/logo.png';
import CrearCotizacion from '../Cotizacion/CrearCotizacion';
import FacebookIcon from '../../Images/facebook.svg';
import WhatsappIcon from '../../Images/whatsapp.svg';
import PhoneIcon from '../../Images/phone.svg';
import EmailIcon from '../../Images/email.svg';

const Header = ({ cartCount }) => {
  const [isDrawerVisible, setDrawerVisible] = useState(false);
  const navigate = useNavigate();

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <header className="App-header">
      <div>
        <div className='icons-left'>
          <a href='https://api.whatsapp.com/send?phone=526642718857&amp;text=Solicito%20informaci%C3%B3n%20de%20un%20producto%20&amp;source=&amp;data=&amp;app_absent=" target="_self'><img src={EmailIcon} alt="whatsapp" width="40" height="40" /></a>
          <a href='https://www.facebook.com/GisMachine/'><img src={PhoneIcon} alt="facebook" width="35" height="35" /></a>
        </div>
        <div className='img-logo'>
          <img src={logopro} alt="Logo" style={{ width: '210px'}} />
        </div>
        
        <div className='icons-right'>
          <a href='https://api.whatsapp.com/send?phone=526642718857&amp;text=Solicito%20informaci%C3%B3n%20de%20un%20producto%20&amp;source=&amp;data=&amp;app_absent=" target="_self'><img src={WhatsappIcon} alt="whatsapp" width="30" height="30" /></a>
          <a href='https://www.facebook.com/GisMachine/'><img src={FacebookIcon} alt="facebook" width="30" height="30" /></a>
        </div>
      </div>
      <nav>
        <ul className="navbar">
          <li><Link to="/inicio">INICIO</Link></li>
          <li><Link to="/empresa">EMPRESA</Link></li>
          <li><Link to="/servicio">SERVICIOS</Link></li>
          <li><Link to="/rf">RF</Link></li>
          <li><Link to="/mro">MRO</Link></li>
          <li><a href='https://www.facebook.com/GisMachine/'>PROMOCIONES</a></li>
          <li><Link to="/tienda">TIENDA</Link></li>
          <li><Link to="/contacto">CONTACTO</Link></li>
          
          {/* Botón de Cotización dentro de la barra de navegación */}
          <li style={{ marginTop: '-5px'}}>
            <Badge count={cartCount} offset={[10, 0]}>
              <Button type="default" shape="round"  onClick={showDrawer} style={{}}>
                <ShoppingCartOutlined /> Cotización
              </Button>
            </Badge>
          </li>
        </ul>
      </nav>

      {/* Sidebar para la cotización */}
      <CrearCotizacion isDrawerVisible={isDrawerVisible} onClose={closeDrawer} />
    </header>
  );
};

export default Header;
